<template>
  <div>
    <page-header />
    <page-features />

    <page-banners v-if="isHomePage" />
    <page-intro v-if="isHomePage" />

    <page-generic v-if="isGeneric" />

    <page-gallery v-if="isGalleryPage" />

    <page-breadcrumb v-if="isProduct" />
    <product-top v-if="isProduct" />
    <page-configurator v-if="isProduct" />
    <product-bottom v-if="isProduct" />

    <page-basket v-if="isBasket" />
    <page-checkout v-if="$route.name == 'checkout'" />

    <page-category
      :category="categories.filter(cat => cat.ItemID == page.ItemID)[0]"
      v-if="page.ItemID && isCategory && categories && categories.length"
    />
    <extras-elem v-if="isExtraCat" />

    <template v-if="isHomePage && categories">
      <span id="products"></span>
      <page-category
        :category="category"
        :key="category.ItemID"
        v-for="category in categories.filter(cat => cat.ItemID != IDs.postsID && cat.ItemID != IDs.ironmongeryID && cat.ItemID != IDs.treatmentsID && cat.products && cat.products.length)"
      />
    </template>

    <page-testimonial v-if="!isTestimonialsPage" />
    <page-questions />
    <page-footer />
  </div>
</template>

<script>
import api from "@/services/api"
import { mapGetters } from "vuex"
import { mapState } from "vuex"

import PageGeneric from "@/components/Generic.vue"
import ProductBottom from "@/components/ProductBottom.vue"
import PageConfigurator from "@/components/Configurator.vue"
import ProductTop from "@/components/ProductTop.vue"
import PageBreadcrumb from "@/components/Breadcrumb.vue"
import PageFooter from "@/components/Footer.vue"
import PageGallery from "@/components/Gallery.vue"
import PageQuestions from "@/components/Questions.vue"
import PageTestimonial from "@/components/Testimonials.vue"
import PageCategory from "@/components/Category.vue"
import PageBanners from "@/components/Banners.vue"
import PageHeader from "@/components/Header.vue"
import PageFeatures from "@/components/Features.vue"
import PageIntro from "@/components/Intro.vue"
import PageBasket from "@/components/Basket.vue"
import PageCheckout from "@/components/Checkout.vue"
import ExtrasElem from "@/components/Extras.vue"

export default {
  name: "page",
  components: {
    PageGeneric,
    PageConfigurator,
    ProductBottom,
    ProductTop,
    PageBreadcrumb,
    PageQuestions,
    PageFooter,
    PageGallery,
    PageTestimonial,
    PageCategory,
    PageBanners,
    PageFeatures,
    PageHeader,
    PageIntro,
    PageBasket,
    PageCheckout,
    ExtrasElem
  },
  data() {
    return {}
  },
  metaInfo() {
    return {
      title: this.$store.state.page.title || "Wortley Brothers Wooden Gates",
      meta: [
        { name: "description", content: this.$store.state.page.meta_desc },
        { name: "keywords", content: this.$store.state.page.meta_keywords }
      ]
    }
  },
  computed: {
    ...mapState(["IDs", "page", "categories"]),
    ...mapGetters([
      "isHomePage",
      "isGalleryPage",
      "isGeneric",
      "isProduct",
      "isCategory",
      "isExtraCat",
      "isBasket",
      "isTestimonialsPage",
      "isSuccess",
      "isFailure"
    ])
  },
  created: function() {
    var route = this.$route
    var url = route.params.url
    var promises = []
    var store = this.$store
    // var state = store.state

    if (!url) store.commit("setPage", {})

    if (route.name == "404") store.commit("setPage", { main_text: "Sorry, this page cannot be found!" })

    if (route.name == "page-by-url" || route.name == "root")
      promises.push(
        api.getPageByURL(url || "default").then(returnedpage => {
          store.commit("setPage", returnedpage)

          if (!returnedpage || !returnedpage.ItemID)
            store.commit("setPage", { main_text: "Sorry, this page cannot be found!" })
        })
      )

    promises.push(store.dispatch("getMainPages"))
    promises.push(store.dispatch("getCategories"))
    promises.push(store.dispatch("getMisc"))
    promises.push(store.dispatch("getContactInfo"))
    promises.push(store.dispatch("getTestimonials"))
    promises.push(store.dispatch("getSizing"))

    Promise.all(promises).then(() => {
      promises = []
      if (this.isSuccess || this.isFailure)
        api.updateOrder(this.$route.query.crypt).then(res => this.$set(this.page, "transaction_response", res.data))

      if (this.isProduct || this.isExtraCat) {
        promises.push(store.dispatch("getPosts"))
        promises.push(store.dispatch("getPricing"))
        promises.push(store.dispatch("getIronmongery"))
        promises.push(store.dispatch("getTreatments"))
      }

      if (this.isProduct || this.isGalleryPage) promises.push(store.dispatch("getGallery"))
      Promise.all(promises).then(() => {
        this.$nextTick().then(() => {
          window.$(document).ready(() => {
            if (this.$route.hash)
              window.$([document.documentElement, document.body]).animate(
                {
                  scrollTop: window.$(this.$route.hash).offset().top
                },
                300
              )

            if (!window.$(".slicknav_menu").length) window.$(".sf-menu").slicknav()

            window.$(".popup").magnificPopup({
              type: "image",
              gallery: {
                enabled: true
              }
            })

            window.$("ul.sf-menu").superfish()

            window
              .$(".testimonial-slideshow")
              .cycle({ slides: ".testimonial-slide", pager: ".testimonial-pager", autoHeight: "calc" })
            window.$(".cycle-slideshow").cycle({ slides: ".slide", pager: ".banner-pager", autoHeight: "calc" })

            window.$(".product-info-link").click(function(e) {
              e.preventDefault()

              //Expand or collapse this panel
              window
                .$(this)
                .next()
                .slideToggle("fast")

              //Hide the other panels
              window
                .$(".product-info-section")
                .not(window.$(this).next())
                .slideUp("fast")
            })

            window.$(".steps > a").click(function(e) {
              e.preventDefault()

              //Expand or collapse this panel
              window
                .$(this)
                .next()
                .slideToggle("fast")

              //Hide the other panels
              window
                .$(".step-info")
                .not(window.$(this).next())
                .slideUp("fast")
            })

            // window.$(".popup").magnificPopup({
            //   type: "image",
            //   gallery: {
            //     enabled: true
            //   }
            // })

            window
              .$(".faqs")
              .find(".accordion-toggle")
              .click(function() {
                window
                  .$(".accordion-toggle")
                  .not(window.$(this))
                  .removeClass("open")

                window.$(this).toggleClass("open")

                //Expand or collapse this panel
                window
                  .$(this)
                  .next()
                  .slideToggle("fast")

                //Hide the other panels
                window
                  .$(".accordion-content")
                  .not(window.$(this).next())
                  .slideUp("fast")
              })

            var magnificPopup = window.$.magnificPopup.instance

            /* Carrega a função quando clica no lightbox (senão não pega a classe utilizada) */
            window.$("a.popup").click(function() {
              /* Espera carregar o lightbox */
              setTimeout(function() {
                /* Swipe para a esquerda - Próximo */
                window.$(".mfp-container").swipe({
                  swipeLeft: function() {
                    magnificPopup.next()
                  },

                  /* Swipe para a direita - Anterior */
                  swipeRight: function() {
                    magnificPopup.prev()
                  }
                })
              }, 500)
            })

            // Select all links with hashes
            window
              .$('a[href*="#"]')
              // Remove links that don't actually link to anything
              .not('[href="#"]')
              .not('[href="#0"]')
              .click(function(event) {
                // On-page links
                if (
                  location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
                  location.hostname == this.hostname
                ) {
                  // Figure out element to scroll to
                  var target = window.$(this.hash)
                  target = target.length ? target : window.$("[name=" + this.hash.slice(1) + "]")
                  // Does a scroll target exist?
                  if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault()
                    window.$("html, body").animate(
                      {
                        scrollTop: target.offset().top
                      },
                      1000,
                      function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = window.$(target)
                        $target.focus()
                        if ($target.is(":focus")) {
                          // Checking if the target was focused
                          return false
                        } else {
                          $target.attr("tabindex", "-1") // Adding tabindex for elements not focusable
                          $target.focus() // Set focus again
                        }
                      }
                    )
                  }
                }
              })
          })
        })
      })
    })
  }
}
</script>
